<template>
  <v-container class="perfil mt-8">
    <portal to="content-before">
      <OrsInnerToolbar
        title="Perfil"
        title-icon="mdi-account"
      />
    </portal>
    <v-layout
      align-center
      justify-center
    >
      <VerifyPhone
        v-if="isVerifying"
        phone="phone"
        @verifyCancel="onCancelVerify"
        @phoneVerified="onVerify"
      />
      <v-flex
        xs10
        md8
        offset-xs1
        offset-md2
        justify-center
      >
        <v-alert
          :value="feedback"
          text
          dismissible
          type="success"
        >
          Informações do perfil atualizadas com sucesso
        </v-alert>
        <v-card
          v-if="currentUser"
          ref="form"
        >
          <v-form v-model="valid">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    ref="name"
                    v-model="name"
                    :disabled="cpfCnpj !== null && cpfCnpj.length>='14'"
                    :rules="[
                      () => !!name || 'Esse campo é obrigatório',
                    ]"
                    label="Nome"
                    placeholder="Digite o nome"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-if="cpfCnpj !== null && cpfCnpj.length>='14'"
                    v-model="email"
                    disabled="true"
                    :rules="[rules.required, rules.email]"
                    label="E-mail"
                    placeholder="Digite o email"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    ref="userName"
                    v-model="login"
                    :rules="[$rules.required()]"
                    label="Username"
                    placeholder="Digite o login"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                  class="cursor-pointer"
                  @click.stop="dialog = true"
                >
                  <v-text-field
                    append-icon="mdi-pencil"
                    type="password"
                    label="Senha"
                  />
                  <OrsEditPassword
                    v-model="dialog"
                    :password="currentUser.password"
                    @change="changeUserPassword"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="cpfCnpj"
                    :disabled="cpfCnpj !== null && cpfCnpj.length>='14'"
                    label="CPF / CNPJ"
                    placeholder="Digite o CPF ou CNPJ"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md3
                >
                  <v-text-field
                    v-model="phone"
                    label="Telefone"
                    placeholder="Digite o telefone"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  md3
                >
                  <v-checkbox
                    v-model="whatsPhone"
                    label="WhatsApp"
                    value="wpp"
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="$router.push({name: 'GuestsList'})"
              >
                Cancelar
              </v-btn>
              <v-btn
                dark
                color="primary"
                rounded
                large
                @click="onContinue"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
      <v-flex
        xs1
        md2
      />
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapGetters, mapActions, mapState
} from 'vuex';
import OrsEditPassword from '@/components/OrsEditPassword.vue';
import OrsInnerToolbar from '@/components/OrsInnerToolbar.vue';
import VerifyPhone from '@/views/VerifyPhone';

export default {
  name: 'Profile',
  components: {
    VerifyPhone,
    OrsInnerToolbar,
    OrsEditPassword,
  },
  data: () => ({
    name: '',
    email: '',
    login: '',
    cpfCnpj: '',
    phone: '',
    whatsPhone: false,
    dialog: false,
    isVerifying: false,
    rules: {
      required: value => !!value || 'Required.',
      counter: value => value.length <= 20 || 'Max 20 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Email incorreto.';
      },
    },
    valid: false,
    feedback: false,
  }),
  computed: {
    ...mapGetters('views/profile', ['currentUser']),
    ...mapState('session', ['currentUser'])
  },
  methods: {
    ...mapActions('views/profile', [
      'findCurrentUser',
      'updateUser',
    ]),
    ...mapActions('login', ['changeUserPassword']),
    onContinue() {
      if (this.phone !== '' && this.phone !== this.currentUser.phone) {
        this.isVerifying = true;
      } else {
        this.onUpdateClick();
      }
    },
    onVerify() {
      this.isVerifying = false;
      this.onUpdateClick();
    },
    onCancelVerify() {
      this.isVerifying = false;
    },
    async onUpdateClick() {
      let whatsPhone;
      if (this.whatsPhone) {
        whatsPhone = this.phone;
      }
      const formData = {
        ...this.currentUser,
        name: this.name,
        email: this.email,
        login: this.login,
        cpfCnpj: this.cpfCnpj,
        phone: this.phone,
        whatsPhone,
      };
      await this.updateUser(formData);
    },
  },
  mounted() {
    this.name = this.currentUser.name;
    this.email = this.currentUser.email;
    this.login = this.currentUser.login;
    this.cpfCnpj = this.currentUser.cpfCnpj;
    this.phone = this.currentUser.phone;
    this.whatsPhone = this.currentUser.whatsPhone;
  },
};
</script>
<!-- Global site tag (gtag.js) - Google Analytics -->
<style lang="stylus" scoped>
.perfil /deep/ {
  // FIXME: Move these css to specific classes to not mess with children components
  .flex.xs10.justify-center {
    text-align: center;
    font-weight: normal;
    color: #555;
    font-size: 36px;
    line-height: 1;
  }
  header.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--flat.white {
      display: none;
  }
  div[role="menu"] .v-list.v-sheet.v-sheet--tile.theme--light {
      margin-top: 0;
      padding: 0;
  }
  .v-list-item.theme--light .v-messages.theme--light {
      display: none;
  }
  .v-list-item.theme--light * {
      margin: 0 !important;
      padding: 0 !important;
  }
  .v-list-item.theme--light label.v-label.theme--light {
      margin-left: 5px !important;
  }
  body .theme--light.v-sheet {
      margin-top: 50px;
  }
  .float-right-inner > div {
      float:  right;
  }
  button.v-btn.v-btn--depressed.v-btn--flat.v-btn--outlined.theme--light.v-size--default {
      margin-top: 15px;
  }
  .v-dialog .v-card.v-sheet.theme--light {
      margin-top: 0 !important;
  }
  button.v-btn.v-btn--flat.v-btn--text.theme--light.v-size--default {
      margin-right: 15px;
  }
  .v-card__title.headline i {
      margin-right: 5px;
  }
  div[role="alert"] {
      margin-top: 0;
      margin-bottom: 30px;
  }
  .cursor-pointer {
      cursor: pointer;
  }
  .cursor-pointer * {
      cursor: pointer;
  }
  html body .v-input--checkbox .v-input__slot {
      margin-bottom: 0 !important;
      position: relative;
      top: 5px;
  }
  .v-menu__content .v-list-item {
      min-height: 30px;
  }
  .v-menu__content .v-list {
      padding: 3px 0 8px !important;
  }
  .v-input.theme--light.v-input--selection-controls.v-input--switch {
      max-width: 90px;
      float: right;
      margin: 0;
  }
  .check-adm .v-input.theme--light.v-input--selection-controls.v-input--checkbox {
      margin-top: 0;
  }
}
</style>
